import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const Login = () => {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();

  return (
    <div className="auth-buttons">
      {!isAuthenticated ? (
        <button onClick={() => loginWithRedirect()} className="login-button">
          LOG IN
        </button>
      ) : (
        <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })} className="logout-button">
          LOG OUT
        </button>
      )}
    </div>
  );
};

export default Login;
